import { render, staticRenderFns } from "./TabImageProductDetailPanel.vue?vue&type=template&id=1ccc97e2&scoped=true"
import script from "./TabImageProductDetailPanel.vue?vue&type=script&lang=js"
export * from "./TabImageProductDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./TabImageProductDetailPanel.vue?vue&type=style&index=0&id=1ccc97e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccc97e2",
  null
  
)

export default component.exports